<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.editDocumentType') }}</h1>
      <div class="form-container">
        <DocumentTypeForm :data="relations.instance" @save="save"></DocumentTypeForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import {mapState} from 'vuex'
  import DocumentTypeForm from "@/components/DocumentTypeForm"

  export default {
    components: {
      DocumentTypeForm,
      DashboardLayout,
    },
    methods: {
      save(payload) {
        this.$store.dispatch('Moderator/update', {actionType: 'document_types', payload}).then(() =>
          this.$router.push({ name: 'documentTypes'}))
      }
    },
    mounted() {
      this.$store.dispatch('Moderator/getRelations', {actionType: 'document_types', id: this.$route.params.id})
    },
    computed: {
      ...mapState('Moderator', ['relations']),
      breadcrumbs() {
        return [
          {name: 'documentTypes', path: 'documentTypes'},
          {name: 'editDocumentType'}
        ]
      }
    }
  }
</script>